export const updateLocalStorageItemInMap = (
  mapName: string,
  key: string | `0x${string}`,
  value: any
) => {
  const map = getMapFromLoacalStorage(mapName);
  map[key] = value;
  localStorage.setItem(mapName, JSON.stringify(map));
};

export const getMapFromLoacalStorage = (mapName: string) =>
  JSON.parse(localStorage.getItem(mapName) ?? "{}");
